
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.25 31.6949C38.25 35.0355 35.53 37.7559 32.19 37.7559C28.85 37.7559 26.13 35.0355 26.13 31.6949C26.13 28.3544 28.85 25.634 32.19 25.634C35.53 25.634 38.25 28.3544 38.25 31.6949ZM47.19 24.1938V39.1961C47.19 43.3368 43.82 46.6973 39.69 46.6973H24.69C20.55 46.6973 17.19 43.3268 17.19 39.1961V24.1938C17.19 20.0531 20.56 16.6926 24.69 16.6926H39.69C43.83 16.6926 47.19 20.0631 47.19 24.1938ZM41.53 31.6949C41.53 26.5441 37.34 22.3435 32.18 22.3435C27.02 22.3435 22.83 26.5341 22.83 31.6949C22.83 36.8558 27.02 41.0464 32.18 41.0464C37.34 41.0464 41.53 36.8558 41.53 31.6949ZM44.18 21.9034C44.18 20.7132 43.22 19.7531 42.03 19.7531C40.84 19.7531 39.88 20.7132 39.88 21.9034C39.88 23.0936 40.84 24.0538 42.03 24.0538C43.22 24.0538 44.18 23.0936 44.18 21.9034ZM64 13.8222V50.1778C64.02 57.819 56.48 64 47.19 64H17.66C7.9 64.01 0 57.509 0 49.4877V13.8422C0 6.20097 7.54 0 16.83 0H47.19C56.48 0 64 6.18096 64 13.8222ZM50.48 24.1938C50.48 18.2428 45.64 13.4021 39.69 13.4021H24.69C18.74 13.4021 13.9 18.2428 13.9 24.1938V39.1961C13.9 45.147 18.74 49.9878 24.69 49.9878H39.69C45.64 49.9878 50.48 45.147 50.48 39.1961V24.1938Z","fill":"#D20311"}})])
          )
        }
      }
    